module.exports = __webpack_public_path__ + "img/aq.aa7bd5b.svg";